export default __webpack_public_path__ + "static/media/1038_1040_nåtade_fällbara_teakbord_kompass.b00d493d.jpg";